"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var editInfo_1 = require("../editInfoUtils/editInfo");
/**
 * Remove explicit width & height attributes on the image element.
 * @param editor The editor that contains the image
 * @param image The image to remove w/h from
 */
function resetImage(editor, image) {
    editor.addUndoSnapshot(function () {
        image.style.width = '';
        image.style.height = '';
        image.style.maxWidth = '100%';
        image.removeAttribute('width');
        image.removeAttribute('height');
        editInfo_1.deleteEditInfo(image);
    }, "ImageResize" /* ImageResize */);
}
exports.default = resetImage;
//# sourceMappingURL=resetImage.js.map